import { type ReactNode } from 'react';
import { useTheme } from '@/shared/ui/theme/ThemeProvider';

interface ModalProps {
  open: boolean;
  onClose: () => void;
  maxWidth?: number;
  zIndex?: number;
  children: ReactNode;
}

export function Modal({ open, onClose, maxWidth = 420, zIndex = 1000, children }: ModalProps) {
  const { T } = useTheme();

  if (!open) return null;

  return (
    <div
      className="mi-anim-fade-in"
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        background: T.modalBg,
        zIndex,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
      }}
    >
      <div
        className="mi-anim-modal-in"
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '100%',
          maxWidth,
          background: T.surfaceBg,
          borderRadius: 16,
          boxShadow: T.shadow,
          border: `1px solid ${T.border}`,
          position: 'relative',
        }}
      >
        {children}
      </div>
    </div>
  );
}
